module.exports={labels:["101-250","1000+","501-1000","251-500","0-10","11-50","51-100"],values:[2,3,3,4,6,7,7]};